import CrudCustom from '../../../libs/custom/CrudCustom';

let SlipGajiService = new CrudCustom('/slip-gaji-pegawais');
export default SlipGajiService;
